export default {
  en: {
    banner: {
      altText: {
        error: 'Error',
        warning: 'Warning',
        info: 'Info',
        success: 'Success',
      },
    },
    dial: {
      altText: 'Dial indicator: {n} percent complete',
    },
    externalLink: {
      altText: 'External link opens in new tab',
    },
    helpIcon: {
      altText: 'Help button',
    },
    pagination: {
      pagination: 'Pagination',
      previousPage: 'Previous page',
      nextPage: 'Next page',
      pageN: 'Page {n}',
    },
    progressBar: {
      altText: 'Progress bar: {n} percent complete',
    },
    spinner: {
      altText: 'Loading',
    },
    spinSucceedFail: {
      saving: 'Saving',
      fail: 'Failed to save',
      success: 'Saved',
    },
    files: {
      loader: {
        text: 'Drag & drop your files here or',
        button: 'Select file',
        error: 'Failed to load file',
      },
      downloadError: 'Error downloading attachment',
      filesAttached: '{n} file attached | {n} files attached',
    },
    debug: {
      userRole: 'Change your user role',
      accountType: 'Change your account type',
      comingSoon: {
        title: 'Coming soon',
        subtitle: 'Nothing to see here just yet...',
      },
      godWillAlert: 'God users will alert!',
      getError: 'Get error',
      goToZeus: 'Zeus',
      goToNetworkGraph: 'Network graph',
      goToSalesFederatedGraph: 'Federated graph (fake data)',
      orgID: 'Org ID:',
      userID: 'User ID:',
      changeRole: 'Change role:',
      setProfileAsIncomplete: 'Set profile as incomplete',
    },
    nav: {
      gettingStarted: 'Getting Started',
      risks: 'Risks',
      myAssurance: 'My assurance',
      mySecurity: 'My security',
      dashboard: 'Dashboard',
      insights: 'Insights',
      beta: 'Beta',
      new: 'New',
      reporting: 'Reporting',
      communities: 'Community',
      visualisation: 'Visualisation',
      network: 'Network',
      map: 'Map',
      actionCentre: 'Action Centre',
      discussions: 'Discussions',
      suppliers: 'Suppliers',
      policies: 'Policies',
      clients: 'Clients',
      assessment: 'Assessment',
      monitoring: 'Monitoring',
      emergingThreats: 'Emerging Threats',
      settings: 'Settings',
      sharing: 'Trust Centre',
      whatIsRL: 'What is Risk Ledger?',
      feedback: 'Feedback?',
      feedbackMessage: 'I would like to give some feedback 👋',
      debugMenu: 'Debug menu',
      popover: {
        contactUs: 'Contact us',
        contactUsMessage: 'I would like some help 👋',
        knowledgeBase: 'Knowledge base',
        helpCentre: 'Help centre',
        signOut: 'Sign out',
      },
      addUsers: 'Add users',
      inviteUsers: 'Invite users',
      version: {
        title: 'Risk Ledger v.{version}',
        updated: 'Updated {date}',
      },
      subEntities: 'Sub-entities',
      documents: 'Documents',
      answerSearch: 'Answer search',
    },
    layout: {
      skipToContent: 'Skip to content',
      skipSecondaryNav: 'Skip secondary navigation',
    },
    tab: {
      scrollLeft: 'Scroll left',
      scrollRight: 'Scroll right',
    },
    infiniteLoader: {
      loadMore: 'Load more',
    },
    confirmModal: {
      title: 'Are you sure?',
      closeButtonText: 'Cancel',
      actionButtonText: 'Confirm',
      checkboxText: 'I understand the consequences of this action.',
    },
    ff: {
      featureFlags: 'Feature flags',
      localStorage: 'The default value has changed, it has been persisted to local storage.',
      reset: 'Reset flags to default',
    },
    orderedLabelEditor: {
      addNew: 'Add level',
      addNewPlaceholder: 'Enter label name...',
      addNewSave: 'Save',
    },
    public: {
      privacyPolicy: 'Privacy Policy',
      termsAndConditions: 'Terms & Conditions',
      copyright: '© Copyright Risk Ledger Ltd {year}',
      rlAddress: 'Adam House, 7-10 Adam St, London, WC2N 6AA, United Kingdom',
    },
    richTextArea: {
      toggleBold: 'Toggle bold',
      toggleItalic: 'Toggle italic',
      toggleUnderline: 'Toggle underline',
      toggleList: 'Toggle list',
      toggleLink: 'Toggle link',
      attachFiles: 'Attach files',
      linkPopover: {
        setTitle: 'Set link',
        updateTitle: 'Update link',
        remove: 'Remove',
        save: 'Save',
      },
    },
    dataTable: {
      empty: 'No rows to display',
      error: 'Failed to get rows',
      status: {
        justNow: 'just now',
      },
      searchPlaceholder: 'Search...',
      columns: 'Columns',
    },
    video: {
      loomCloseButton: 'Close',
    },
    layouts: {
      applicationLoadError: {
        message: 'The application has failed to load.',
        stepsToFollowHeader: 'To resolve this, try the following steps:',
        tryRefreshing: 'Try refreshing your browser',
        openSiteInPrivacyMode: 'Try opening this site in incognito/privacy mode',
        ensureWhitelistedDomains: 'Ensure riskledger domains are whitelisted by your IT team',
        contactUsThroughIntercom:
          'If none of the above work, contact our support staff by clicking here.',
        intercomMessage: "I'm experiencing an issue with the application loading.",
      },
    },
    cancelWarningModal: {
      title: 'Are you sure you want to leave?',
      body: "Any changes you've made will be lost.",
      no: 'Keep editing',
      yes: 'Yes, leave',
    },
    copyLink: {
      copyTooltip: 'Copy the link to your clipboard.',
      copySuccess: 'Successfully copied link',
    },
    baseInputSelect: {
      noOptions: 'No other options',
    },
    visualisation: {
      zoomIn: 'Zoom in',
      zoomOut: 'Zoom out',
      zoomToFit: 'Zoom to fit',
    },
  },
};
